import React from "react";
import brand from "../config/brand";

const getInitial = () =>
  (brand.shortName || brand.casinoName || "C").slice(0, 1).toUpperCase();

const brandMark = ({ size = 36, className = "" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 40 44"
    height={size}
    width={size}
    className={className}
    style={{ display: "block", flex: "0 0 auto" }}
    role="img"
    aria-label={`${brand.fullName} logo`}
  >
    <polygon points="20,2 38,22 20,42 2,22" fill="#FFD700" />
    <polygon points="20,9 32,22 20,35 8,22" fill="#1A1D29" opacity="0.45" />
    <text
      x="20"
      y="28"
      textAnchor="middle"
      fontFamily="Arial Black, sans-serif"
      fontWeight="900"
      fontSize="16"
      fill="#1A1D29"
    >
      {getInitial()}
    </text>
  </svg>
);

export const TvLogoFull = ({ height = 36, className = "" }) => {
  if (brand.logoUrl) {
    return (
      <img
        src={brand.logoUrl}
        alt={`${brand.fullName} logo`}
        height={height}
        className={className}
        style={{ display: "block", objectFit: "contain" }}
      />
    );
  }

  return (
    <div
      className={className}
      style={{
        alignItems: "center",
        display: "inline-flex",
        gap: Math.max(6, height * 0.22),
        height,
        lineHeight: 1,
      }}
      aria-label={`${brand.fullName} logo`}
    >
      {brandMark({ size: height })}
      <div>
        <div
          style={{
            color: "#FFD700",
            fontFamily: "Arial Black, sans-serif",
            fontSize: Math.max(16, height * 0.55),
            fontWeight: 900,
            letterSpacing: 1.4,
            textTransform: "uppercase",
            whiteSpace: "nowrap",
          }}
        >
          {brand.casinoName}
        </div>
        <div
          style={{
            color: "#9ca3af",
            fontFamily: "Arial, sans-serif",
            fontSize: Math.max(8, height * 0.22),
            letterSpacing: 4,
            textTransform: "uppercase",
            whiteSpace: "nowrap",
          }}
        >
          {brand.casinoType}
        </div>
      </div>
    </div>
  );
};

export const TvLogoIcon = ({ size = 36, className = "" }) => {
  if (brand.iconUrl || brand.logoUrl) {
    return (
      <img
        src={brand.iconUrl || brand.logoUrl}
        alt={`${brand.fullName} logo`}
        height={size}
        width={size}
        className={className}
        style={{ display: "block", objectFit: "contain" }}
      />
    );
  }

  return brandMark({ size, className });
};

export const BrandLogoFull = TvLogoFull;
export const BrandLogoIcon = TvLogoIcon;

export default TvLogoFull;
